import {
   Autocomplete,
   Button,
   Dialog,
   DialogActions,
   DialogContent,
   DialogTitle,
   TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import uploadImg from "../../../../../assets/images/uploadImg.svg";
import useEvents from "../../../../../hooks/useEvents";
import useInput from "../../../../../hooks/useInput";
import useResources from "../../../../../hooks/useResources";
import useResourceTypes from "../../../../../hooks/useResourceTypes";
import { validators } from "../../../../../utilities/inputValidator";
import Spinner from "../../../../components/spinner/spinner";
import classes from "./AddResource.module.css";

const AddResource = () => {
   const {
      resources: { resource, openForm, createLoading },
      resourceType: { resourceTypeResponse },
      events: { createLoading: eventCreateLoading },
   } = useSelector((state) => state);

   const [imgSelected, setImageSelected] = useState("");
   const [cloudiaryUrl, setCloudiaryUrl] = useState(null);
   const [search] = useState("");

   const { addResource, closeResourceForm } = useResources();
   const { onSetResourceType } = useResourceTypes();

   const resourceType = onSetResourceType(resource);

   const [singleResourceType, setSingleResourceType] = useState(resourceType);

   const { cloudinaryApi } = useEvents();

   const {
      value: name,
      valueInputChange: nameInputChange,
      valueIsValid: nameIsValid,
      hasError: nameHasError,
      inputBlurHandler: nameBlurHandler,
   } = useInput(validators.checkValueIsEmpty, `${resource.name ?? ""}`);

   const { value: paymentLink, valueInputChange: paymentLinkInputChange } =
      useInput(validators.checkValueIsEmpty, `${resource.paymentLink ?? ""}`);

   const { value: pdfUrl, valueInputChange: pdfInputChange } = useInput(
      validators.checkValueIsEmpty,
      `${resource.pdfUrl ?? ""}`
   );

   useEffect(() => {
      onSetResourceType(resource);
   }, [search]);

   const cloudUrl = cloudiaryUrl ?? pdfUrl;

   const uploadToCloudiary = async () => {
      const data = await cloudinaryApi(imgSelected);
      setCloudiaryUrl(data?.secure_url);
   };

   const onAddResourceType = () => {
      if (!formIsValid) {
         return;
      }

      const reqBody = {
         name,
         pdfUrl: cloudUrl,
         resourceTypeId: singleResourceType.id,
         paymentLink,
      };

      reqBody.id = resource.id && resource.id;

      addResource(reqBody);
   };

   const dropDownChange = (_, value) => {
      setSingleResourceType(value);
   };

   const formIsValid = nameIsValid && cloudUrl && singleResourceType?.id;
   return (
      <Dialog
         open={openForm}
         onClose={closeResourceForm}
         onBackdropClick={null}
      >
         <DialogTitle>Add Resource</DialogTitle>
         <DialogContent>
            <TextField
               autoFocus
               margin="dense"
               label="Name"
               type="text"
               fullWidth
               variant="outlined"
               value={name}
               onChange={nameInputChange}
               onBlur={nameBlurHandler}
               error={nameHasError}
               style={{ margin: "10px 0" }}
            />

            <Autocomplete
               disablePortal
               options={resourceTypeResponse?.content ?? []}
               getOptionLabel={(option) => option?.name ?? ""}
               onChange={dropDownChange}
               value={singleResourceType}
               isOptionEqualToValue={(option) =>
                  option.id === singleResourceType.id
               }
               renderInput={(params) => (
                  <TextField {...params} fullWidth label="Resource type" />
               )}
               style={{ margin: "10px 0" }}
            />

            <TextField
               margin="dense"
               label="Payment link"
               type="text"
               fullWidth
               variant="outlined"
               value={paymentLink}
               onChange={paymentLinkInputChange}
               style={{ margin: "10px 0" }}
            />

            <TextField
               margin="dense"
               label="Resource link"
               type="text"
               fullWidth
               variant="outlined"
               value={pdfUrl}
               onChange={pdfInputChange}
               style={{ margin: "10px 0" }}
            />

            <div className={classes.uploadContainer}>
               <p>
                  Event Image: <span>{imgSelected.name} </span>{" "}
               </p>
               <span>
                  Cloudinary Url: <span>{resource.pdfUrl ?? cloudiaryUrl}</span>
               </span>

               <div className={classes.upload}>
                  <img src={uploadImg} alt="upload" />
                  <input
                     type="file"
                     id="files"
                     onChange={(event) => {
                        setImageSelected(event.target.files[0]);
                     }}
                     className={classes.hidden}
                  />
                  <label htmlFor="files" className={classes.label}>
                     You can drag and drop or select from <span>here</span>
                  </label>
               </div>

               <div className={classes.cloudinaryButtonContainer}>
                  {imgSelected.name && (
                     <Button onClick={uploadToCloudiary} variant="contained">
                        Upload to Cloudinary
                     </Button>
                  )}
               </div>
            </div>
         </DialogContent>
         <DialogActions>
            <Button onClick={closeResourceForm}>Cancel</Button>
            <Button
               className={classes.button}
               variant="contained"
               onClick={onAddResourceType}
               disabled={!formIsValid}
            >
               Save
            </Button>
         </DialogActions>

         {(createLoading || eventCreateLoading) && <Spinner />}
      </Dialog>
   );
};

export default AddResource;
